
import on_domready from "domready"

import Users from "./users/onLoad"

const onLoad = () => {
  on_domready(() => {
    Users.onLoad()
  })
}

export default {onLoad}
